import React from "react";
import { useTranslation } from 'react-i18next';


const YesSelection = ({ handleRephraseClick, handleChangeSelectionsClick ,hideButtons}) => {
      const { t, i18n } = useTranslation();
  
    if (hideButtons) {
        return <div className="py-2"></div>;
      }
  return (
    <div>
      <div className="yesSelectionPnc">{t('whatToDO')} </div>

      <div className="flex gap-4 mt-2 flex-col sm:flex-row">
        <button
          className="px-4 py-2 bg-[transparent] border border-[#E63946] rounded-md hover:bg-[#FDF2F3] transition-colors yesBtnPnc w-full sm:flex-1 rephrasePnc min-w-[194px]" 
          onClick={() => handleRephraseClick("rephrase")}
        >
         {t('rephraseQues')}
        </button>
        <button
          className="px-4 py-2 bg-[transparent] border border-[#E63946] rounded-md hover:bg-[#FDF2F3] transition-colors yesBtnPnc w-full sm:flex-1 min-w-[194px]"
          onClick={() => handleChangeSelectionsClick("change")}
        >
          {t('changeSelection')}
        </button>
      </div>
    </div>
  );
};

export default YesSelection;